"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Severity = void 0;
var Severity;
(function (Severity) {
    Severity[Severity["SUCCESS"] = 0] = "SUCCESS";
    Severity[Severity["WARNING"] = 1] = "WARNING";
    Severity[Severity["ALERT"] = 2] = "ALERT";
    Severity[Severity["INFO"] = 3] = "INFO";
})(Severity = exports.Severity || (exports.Severity = {}));
//# sourceMappingURL=severity.enum.js.map